export const faqAssets = {
	arrow: "/spec_faq/arrow.svg",
	background: "/spec_faq/bg_v2.png",
	backgroundMobile: "/spec_faq/bg-mobile.png",
	brushMobile: "/spec_faq/brush-mobile.png",
	loyalty: "/spec_faq/loyalty.png",
	mini1: "/spec_faq/mini1.png",
	mini2: "/spec_faq/mini2.png"
} as const;
